<template>
  <proa-card>
    <proa-list-group>
      <proa-list-group-item
        v-for="notification in notifications"
        :key="notification.id"
        @click.native="onClickNotification(notification)"
        class="notification-container"
      >
        <div class="title" v-if="notification.notificationType === 'privateChat' || notification.notificationType === 'cafeRoomMember'">
          <proa-avatar :src="notification.getPostUser().meta.avatar || require('@/assets/images/avatar_default.png')" size="xs" class="title-avatar"/>
          <span>{{ notification.getPostUser().meta.displayName }}</span>
        </div>
        <div class="title" v-else-if="notification.notificationType === 'groupChat'">
          <proa-badge :value="notification.meta.unreadCount" class="title-badge"/>
          <span>{{ notification.title }}</span>
        </div>
        <div class="title" v-else>
          <span>{{ notification.title }}</span>
        </div>
        <div class="message">{{ notification.message }}</div>
        <div class="notified-at">
          <span>{{ notification.notifiedAt | momentDiff() }}</span>
        </div>
      </proa-list-group-item>
      <proa-list-group-item v-if="enableChangeLimit" class="d-flex justify-content-center">
        <span
          @click="$emit('changeLimited', !limited)"
          :class="['limited-accordion', limited ? 'accordion-open' : 'accordion-close' ]"
        />
      </proa-list-group-item>
    </proa-list-group>
  </proa-card>
</template>

<script>
export default {
  name: 'NotificationsCard',
  props: {
    notifications: Array,
    enableChangeLimit: Boolean,
    limited: Boolean
  },
  methods: {
    onClickNotification: function(notification) {
      switch (notification.notificationType) {
        case 'groupChat': {
          this.$router.push({ name: 'showChat', params: { id: notification.relatedId } })
          break
        }
        case 'privateChat': {
          this.$router.push({ name: 'showMember', params: { id: notification.senderId, defaultMenu: 'privateChat' } })
          break
        }
        case 'projectChat': {
          this.$router.push({ name: 'showProject', params: { id: notification.additinalId, defaultMenu: 'projectChat' } })
          break
        }
        case 'groupChatMember': {
          this.$router.push({ name: 'showChat', params: { id: notification.relatedId } })
          break
        }
        case 'cafeRoomMember': {
          this.$router.push({ name: 'indexRoom', params: {
            videoRoomMasterId: notification.additinalId,
            id: notification.relatedId
          }})
          break
        }
        case 'videoRoomMember': {
          this.$router.push({ name: 'showMeetingReservations', params: {
            videoRoomMasterId: notification.additinalId,
            id: notification.relatedId,
            returnPath: 'my_space'
          }})
          break
        }
        case 'projectMember': {
          this.$router.push({ name: 'showProject', params: { id: notification.relatedId } })
          break
        }
        case 'taskCardAssignees': {
          this.$router.push({ name: 'showProjectTaskCards', params: {
            projectId: notification.additinalId,
            id: notification.relatedId
          }})
          break
        }
        // TODO: その他の実装
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.notification-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  .title {
    flex-shrink: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 40%;

    @include mq(md) {
      width: 25%;
    }

    .title-badge {
      position: relative;
      bottom: 1.5px;
    }

    .title-badge, .title-avatar {
      margin-right: 10px;
    }
  }

  .message {
    flex-shrink: 1;
    flex-grow: 1;
    color: $light-text-color;
    font-size: 12px;
    padding: 0 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .notified-at {
    color: $light-text-color;
    font-size: 11px;
    white-space: nowrap;
  }
}

.limited-accordion {
  width: 90px;
  height: 35px;
  background: #FFFFFF;
  border: 1px solid $dark-border-color;
  border-radius: 4px;
  cursor: pointer;
  pointer-events: auto;
  position: relative;
  color: #666666;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background: $light-gray-color;
  }

  &::before {
    content:  '';
    width: 10px;
    height: 10px;
    display:  block;
    border-top: solid 1px;
    border-right: solid 1px;

  }

  &.accordion-open::before {
    transform: rotate(135deg);
    margin-bottom: 4px;
  }

  &.accordion-close::before {
    transform: rotate(-45deg);
    margin-top: 4px;
  }
}
</style>
